import { createStore } from 'store-utils';
import { Role } from '../types/members-types';

const AvailableRolesStore = createStore<AvailableRolesStoreState>(
  {
    availableRoles: [],
    isLoading: false,
  },
  'Available Roles Store',
);

interface AvailableRolesStoreState {
  availableRoles: Role[];
  isLoading: boolean;
}

export default AvailableRolesStore;
